/* 太史慈傳・第 3 章：射麻保賊（建安初，年份不詳；在孫策生前）
 * 史實：《三國志·太史慈傳》「慈長七尺七寸，美鬚髯，猿臂善射，弦不虛發。嘗從策討麻保賊，賊於屯裏緣樓上行詈，
 *       以手持樓棼，慈引弓射之，矢貫手著棼，圍外萬人莫不稱善。其妙如此。」
 * 流程：1. 從圍營走到屯門前，城頭的箭會先在地上畫出紅圈再落下。
 *       2. 屯門的樓上有一個賊沿著樓走、一邊罵；每隔幾秒停下來「以手持樓棼」（頭上有標記）。只有那一下射中才算「貫手」；
 *          他走動時射中只是擦過，他會縮回樓裡一陣子。
 *       3. 圍外萬人莫不稱善：賊兵氣沮，屯門打開，賊帥帶最後的人衝出來；擊敗賊帥即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, rout } from '../kit.ts';
import { TSC_PEOPLE, TSC_TROOPS, tower } from './taishici_kit.ts';
import { TUN, GATE, LOU, CAMP, FRONT, ARROW_Y } from '../maps/taishici_mabao.ts';

const LV = 10, SPAN = 170, GRAB = 1.5, FAR = 520;
const CURSES = ['孫郎小兒，有本事打進來！', '江東鼠輩，圍了這麼多天，連門都摸不著！', '射啊！你們射得中嗎？', '太史子義？降將而已！'];
const ZEI = { spec: TSC_TROOPS.mabao, name: '麻保賊', hp: 560, maxHp: 560, atk: 26 };

export default {
  id: 'taishici-3', map: 'taishici_mabao', hero: 'taishici',
  title: '第 3 章　射麻保賊', year: '建安初（196–200）',
  brief: {
    quote: [
      { text: '慈長七尺七寸，美鬚髯，猿臂善射，弦不虛發。', src: '《三國志·吳書·太史慈傳》' },
      { text: '嘗從策討麻保賊，賊於屯裏緣樓上行詈，以手持樓棼，慈引弓射之，矢貫手著棼，圍外萬人莫不稱善。', src: '《太史慈傳》' },
    ],
    text: '太史慈如期回來之後，孫策「常與參論諸軍事」。孫策征討麻保的賊，賊據屯死守，孫軍圍在外面。賊人爬上屯門的樓，對著城外叫罵。（正文沒寫年份，只知道在孫策生前。）',
    goals: ['冒著城頭的箭走到屯門前', '等樓上的賊「以手持樓棼」時射他的手', '屯門打開：擊敗賊帥'],
  },
  words: { ally: '孫軍', foe: '麻保賊' },
  stars: [
    { text: '弦不虛發：第一箭就貫手', ok: (m) => m.vars.pinned && !m.vars.miss },
    { text: `遠射：在 ${FAR} 以外射中`, ok: (m) => m.vars.farShot },
    { text: '逼近時被城頭的箭打中不超過 3 次', ok: (m) => m.vars.hits <= 3 },
  ],
  steps: [
    { // 0. 冒箭逼近
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0] + 150; me.y = CAMP[1] - 200;
        V.hits = 0; V.miss = 0; V.arrowT = 2;
        m.gate('gate', GATE[0], GATE[1], 200, 'citygate');
        V.lou = m.folk(LOU[0], LOU[1] - 30, { name: '樓', still: true, near: 1, draw: tower });
        V.ce = ally(w, 'sunce', CAMP[0] - 200, CAMP[1] - 250, LV); V.ce.hold = [CAMP[0] - 200, CAMP[1] - 250];
        // 圍外萬人：孫軍在屯外圍一圈（站著不動）
        V.wei = [];
        for (let i = 0; i < 14; i++) { const x = TUN.x - 1500 + i * 230, y = i % 2 ? 2750 : 2900, u = m.recruit(x, y, '孫軍'); u.spec = SG.SOLDIERS.wu; u.home = [u.x, u.y]; V.wei.push(u); }
        // 樓上的賊
        V.rail = m.foe('huangjin', LOU[0], LOU[1] + 300, Object.assign({}, ZEI, { name: '樓上的賊', hp: 9999, maxHp: 9999, atk: 0, ms: 0, armor: 0, gold: 0, xp: 0 }));
        V.rail.x = LOU[0]; V.rail.y = LOU[1]; V.rail.home = null;
        Object.assign(V, { pose: 'walk', poseT: 3, dir: 1, hp0: V.rail.hp });
        m.line('孫策', '這屯硬得很。子義，你去門前看看。');
        m.after(3, () => m.line('提示', '城頭會放箭：地上出現紅圈就快閃開。走到屯門前。'));
        m.mark('front', FRONT[0], FRONT[1] - 200, '屯門前');
        m.obj('front', '冒箭走到屯門前');
      },
      tick(m, w) { return m.near(w.player, FRONT[0], FRONT[1] - 250, 260); },
    },
    { // 1. 矢貫手著棼
      enter(m, w) {
        m.done('front'); m.unmark('front');
        m.line('樓上的賊', CURSES[0]);
        m.after(3, () => m.line('提示', '樓上的賊沿著樓走、一邊罵。他停下來抓住樓棼（頭上出現標記）的那一下射他的手；走動時射中只是擦過，他會縮回去。'));
        m.after(7, () => m.line('提示', '普攻要站到樓下；「弦不虛發」（弓的第一招）射得比普攻遠。'));
        m.obj('pin', '射樓上那個賊的手');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, r = V.rail;
        r.target = null; r.think = 1;
        if (r.hp < V.hp0 - 1) { // 射中了
          const d = SG.gd(me.x, me.y, r.x, r.y);
          r.hp = r.maxHp;
          if (V.pose === 'grab' || w.t - (V.grabEnd || -9) < 0.6) { // 箭在空中飛的時間：他鬆手後 0.6 秒內射到也算
            V.pinned = true; V.farShot = d >= FAR;
            w.fx({ k: 'spark', x: r.x, y: r.y - 60, col: '#ffd46b' });
            return true;
          }
          if (V.pose !== 'duck') { V.miss++; V.pose = 'duck'; V.poseT = 3; r.untargetable = true; m.line('樓上的賊', '哎喲！……沒射中要害吧！'); m.unmark('grab'); }
        }
        V.hp0 = r.hp;
        V.poseT -= dt;
        if (V.pose !== 'duck') r.y = LOU[1]; // 站在樓上（引擎會把人推出屯門，這裡每一步放回去）
        if (V.pose === 'walk') {
          r.x += V.dir * 80 * dt; if (Math.abs(r.x - LOU[0]) > SPAN) { V.dir = -V.dir; r.x = LOU[0] + Math.sign(r.x - LOU[0]) * SPAN; }
          r.f = V.dir;
          if (V.poseT <= 0) { V.pose = 'grab'; V.poseT = GRAB; m.mark('grab', r.x, r.y, '以手持樓棼', true); if (SG.rand() < 0.5) m.line('樓上的賊', CURSES[(V.cur = ((V.cur || 0) + 1)) % CURSES.length]); }
        } else if (V.pose === 'grab') {
          if (V.poseT <= 0) { V.pose = 'walk'; V.poseT = 2.5 + SG.rand() * 2; V.grabEnd = w.t; m.unmark('grab'); }
        } else if (V.pose === 'duck') {
          r.y = LOU[1] - 60;
          if (V.poseT <= 0) { V.pose = 'walk'; V.poseT = 2 + SG.rand() * 2; r.untargetable = false; r.y = LOU[1]; m.line('樓上的賊', '再來啊！'); }
        }
        return false;
      },
    },
    { // 2. 圍外萬人莫不稱善；賊帥衝出
      enter(m, w) {
        const V = m.vars, r = V.rail;
        m.done('pin'); m.unmark('grab');
        m.big('矢貫手著棼！');
        m.card('慈引弓射之，矢貫手著棼，圍外萬人莫不稱善。其妙如此。', '《太史慈傳》');
        r.untargetable = true; V.pose = 'pinned';
        m.line('孫軍', '好！');
        m.after(2, () => m.line('孫策', '子義這一箭，賊膽已破。攻門！'));
        m.after(5, () => {
          m.ungate('gate');
          m.big('屯門開了');
          vanishRail(w, r);
          V.chief = boss(w, TSC_PEOPLE.mabao, TUN.x, TUN.y + 300, { name: '麻保賊帥', hp: 3000, maxHp: 3000, atk: 40, armor: 6 });
          V.chief.home = [FRONT[0], FRONT[1]];
          V.zei = Array.from({ length: 8 }, (_, i) => { const u = m.foe('huangjin', TUN.x - 300 + (i % 4) * 150, TUN.y + 150 + Math.floor(i / 4) * 120, ZEI); u.home = [FRONT[0], FRONT[1]]; return u; });
          V.ce.hold = null; // 孫策也殺上來
          for (const u of V.wei) u.home = [FRONT[0] + (SG.rand() - 0.5) * 600, FRONT[1] - 200];
          m.line('麻保賊帥', '跟他們拼了！');
          m.mark('chief', V.chief.x, V.chief.y, '賊帥', false, V.chief);
          m.obj('chief', '擊敗麻保賊帥');
        });
      },
      tick(m) {
        const V = m.vars;
        return !!V.chief && !V.chief.alive;
      },
    },
    { // 3. 平定
      enter(m, w) {
        const V = m.vars;
        m.done('chief'); m.unmark('chief');
        rout(m, w, V.zei, [TUN.x, 700]);
        m.line('孫策', '好一個弦不虛發！');
        m.after(4, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w, dt) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose(m.i <= 1 ? '太史慈中箭陣亡' : '太史慈陣亡'); return; }
    if (V.ce) allyTick(w, V.ce, me, 500);
    // 城頭放箭（屯門打開前）：瞄著太史慈前方落下
    if (V.px != null) { const k = Math.min(1, dt * 5), vx = (me.x - V.px) / dt, vy = (me.y - V.py) / dt; V.vel = V.vel ? [V.vel[0] + (vx - V.vel[0]) * k, V.vel[1] + (vy - V.vel[1]) * k] : [vx, vy]; }
    V.px = me.x; V.py = me.y;
    if (m.i <= 1 && me.y < ARROW_Y) {
      V.arrowT -= dt;
      if (V.arrowT <= 0) {
        V.arrowT = m.i === 0 ? 0.9 : 3; // 在樓下等時機時，箭比較稀
        const vx = V.vel ? V.vel[0] : 0, vy = V.vel ? V.vel[1] : 0; // 瞄著他一秒後會走到的地方
        const x = me.x + vx * 0.9 + (SG.rand() - 0.5) * 60, y = me.y + vy * 0.9 + (SG.rand() - 0.5) * 40;
        m.warn({ x, y, r: 110, t: 1.0, col: '#ff5040', fn: (hit) => { for (const u of hit) if (u.team === 0) { m.hurt(u, m.i === 0 ? 70 : 50, 1, { stagger: 0.2 }); if (u === me && m.i === 0) V.hits++; } w.fx({ k: 'boom', x, y, r: 110, col: '#c86a3a' }); } });
      }
    }
  },
};

// 樓上的賊被釘住：從場上拿掉（賊兵退回屯裡）
function vanishRail(w, r) { r.alive = false; r.counted = true; r.deadT = w.t; }
